import React from "react";
import { useForm } from "react-hook-form";

import SelectWithSearch from "../../../GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";
import InputForForm from "../../../GeneralComponents/componentsForForm/inputForForm/InputForForm";

import styles from "./searchForAuditActionsSystem.module.css";

function SearchForAuditActionsSystem({ inputOptions, getSearchData }) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const resolveSubmit = (data) => {
    getSearchData(data);
  };

  function handleClean(e) {
    e.preventDefault();
    getSearchData({ fio: "", logDocNum: "", startDate: "", endDate: "" });
    reset();
    return undefined;
  }

  return (
    <form
      className={styles["form-inputs"]}
      onSubmit={handleSubmit(resolveSubmit)}>
      <div className={styles["inputs-block"]}>
        {Object.values(inputOptions).map((option) => {
          switch (true) {
            case option.type === "selectWithSearch": {
              return (
                <div
                  key={option.key}
                  className={styles[`box-${option.key}`]}>
                  <SelectWithSearch
                    inputProps={option}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                  />
                </div>
              );
            }
            default:
              return (
                <div
                  key={option.key}
                  className={styles[`box-${option.key}`]}>
                  <InputForForm
                    register={register}
                    inputProps={option}
                    errors={errors}
                    setValue={setValue}
                  />
                </div>
              );
          }
        })}
      </div>
      <div className={styles["buttons-block"]}>
        <button className={styles["search-btn"]}>
          <span className={styles["search-icon"]}></span>
          <span>Найти</span>
        </button>
        <button
          className={styles["clear-btn"]}
          onClick={(e) => handleClean(e)}>
          Очистить
        </button>
      </div>
    </form>
  );
}

export default SearchForAuditActionsSystem;
